import axios from "axios";

const instance = axios.create({
    // The Api (cloud function) url
    baseURL: "https://us-central1-fir-9849c.cloudfunctions.net/api",
});

export default instance;
